import React, { useEffect } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import Zone from "@/components/site/Zone";
import Realisations from "@/components/site/Realisations";
import Pourquoi from "@/components/site/Pourquoi";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  useEffect(() => {
    document.title = "ETANCIA · Étanchéité professionnelle";
  }, []);

  return (
    <main data-testid="landing-page" className="min-h-screen bg-white text-slate-900">
      <Navbar />
      <Hero />
      <Services />
      <Zone />
      <Realisations />
      <Pourquoi />
      <Contact />
      <Footer />
    </main>
  );
}
